<template>
  <div id="main-bandaid">
    <div id="bandaid">
      <a
        v-if="quantity > 0" 
        href="#"
        class="bandaid-sign-neg"
        @click="lessQuantity"
        >-</a
      >
      <span class="bandaid-sign">{{ quantity }}</span>
      <a 
        v-if="stockQuantity > quantity" 
        href="#" 
        class="bandaid-sign-plus" 
        @click="plusQuantity"
      >+</a>
    </div>
  </div>
</template>
<script>
import mobile_detection from "../mixins/mobile_detection";
export default {
  mixins: [mobile_detection],
  name: "BandAid",
  props: {
    quantity: {
      type: Number,
      default: () => {
        return {};
      },
    },
    stockQuantity: {
      type: Number,
      default: () => {
        return 0;
      },
    }
  },
  data() {
    return {};
  },
  methods: {
    plusQuantity(e) {
      e.preventDefault();
      this.$emit("plusQuantity");
    },
    lessQuantity(e) {
      e.preventDefault();
      this.$emit("lessQuantity");
    },
  },
};
</script>
<style scoped>
#main-bandaid {
  float: right;
}
.bandaid-sign {
  line-height: normal;
  display: inline;
  font-size: 1.5em;
  text-decoration: none;
  color: #0D6496 !important;
}
.bandaid-sign-neg {
  line-height: normal;
  display: inline;
  font-size: 1.5em;
  float: left;
  margin-left: 0.5em;
  text-decoration: none !important;
  color: #0D6496 !important;
}
.bandaid-sign-plus {
  line-height: normal;
  display: inline;
  float: right;
  margin-right: 0.5em;
  font-size: 1.5em;
  color: #0D6496 !important;
}
.bandaid-sign-plus:hover {
  font-weight: 900;
}
.bandaid-sign-neg:hover {
  font-weight: 900;
}

#bandaid-amount {
  color: #0D6496 !important;
  font-weight: 600;
  display: inline;
}
#bandaid {
  /* vertical-align: middle; */
  border-radius: 25px;
  border: 1px solid #0D6496 !important;
  color: #0D6496 !important;
  width: 5em;
  text-align: center;
  /* margin: 0 auto; */
}
</style>



// WEBPACK FOOTER //
// src/Components/BandAid.vue